import { useAtom, useAtomValue } from "jotai";
import { useRouter } from "next/router";

import { checkIsContainsPlusQueryString } from "scmp-app/components/article/article-render/plus/helpers";
import { gdprAtom } from "scmp-app/components/gdpr-banner/atoms";
import { hamburgerMenuAtom } from "scmp-app/components/hamburger-menu/atoms";
import { headerAllMenuAtom } from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/atoms";
import { loginDialogAtom } from "scmp-app/components/login-dialog/atoms";
import { useArticleCommentLink } from "scmp-app/lib/hooks";

export const useAcquisitionPopupContainerWrapper = () => {
  const { isAccepted: isAcceptedGDPR } = useAtomValue(gdprAtom);
  const router = useRouter();

  const loginDialogState = useAtom(loginDialogAtom);
  const hamburgerMenuAtomState = useAtomValue(hamburgerMenuAtom);
  const headerAllMenuPopupState = useAtomValue(headerAllMenuAtom);

  const { isCommentLink } = useArticleCommentLink();

  if (checkIsContainsPlusQueryString(router.query)) return { shouldShowAcquisitionPopup: false };

  const needToShow =
    !loginDialogState[0].isVisible &&
    isAcceptedGDPR &&
    !hamburgerMenuAtomState.isOpen &&
    !isCommentLink() &&
    !headerAllMenuPopupState.isOpen;

  return {
    shouldShowAcquisitionPopup: needToShow,
  };
};
